export default `uniform vec3 color;

void main() {
    vec2 xy = gl_PointCoord.xy - vec2(0.5);
    float lineWidth = 0.1; 

    
    float cosTheta = cos(3.14159265 * 0.25); 
    float sinTheta = sin(3.14159265 * 0.25); 

    
    vec2 rotatedXY = vec2(
        cosTheta * xy.x - sinTheta * xy.y,
        sinTheta * xy.x + cosTheta * xy.y
    );

    
    
    float distX = abs(rotatedXY.x); 
    float distY = abs(rotatedXY.y); 

    
    float alphaX = 1.0 - step(lineWidth, distX);
    float alphaY = 1.0 - step(lineWidth, distY);

    
    float alpha = max(alphaX, alphaY);

    gl_FragColor = vec4(color, alpha);
}`